// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  width: 100%;
  height: 100%;
  font-family: Inter, sans-serif;
}

body {
  margin: 0;
}

* {
  font-family: Inter, sans-serif;
}

::-webkit-scrollbar {
  width: 5px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  background-color: rgb(38 39 50 / 50%);
  border-radius: 6px;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

/** Переопределяет css переменные библиотеки emoji-picker-react */
.EmojiPickerReact {
  --epr-emoji-size: 22px;
  --epr-search-input-height: 35px;
  --epr-header-padding: 4px var(--epr-horizontal-padding);
  --epr-category-navigation-button-size: 25px;
  --epr-category-label-height: 25px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iEAAiE;AACjE;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,uDAAuD;EACvD,2CAA2C;EAC3C,iCAAiC;AACnC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');\n\nhtml,\nbody {\n  width: 100%;\n  height: 100%;\n  font-family: Inter, sans-serif;\n}\n\nbody {\n  margin: 0;\n}\n\n* {\n  font-family: Inter, sans-serif;\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  height: 6px;\n}\n\n::-webkit-scrollbar-thumb {\n  background-color: rgb(38 39 50 / 50%);\n  border-radius: 6px;\n}\n\n::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n/** Переопределяет css переменные библиотеки emoji-picker-react */\n.EmojiPickerReact {\n  --epr-emoji-size: 22px;\n  --epr-search-input-height: 35px;\n  --epr-header-padding: 4px var(--epr-horizontal-padding);\n  --epr-category-navigation-button-size: 25px;\n  --epr-category-label-height: 25px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
